"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RegistryAccess__factory", {
  enumerable: true,
  get: function get() {
    return _RegistryAccess__factory.RegistryAccess__factory;
  }
});
Object.defineProperty(exports, "SBTUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _SBTUpgradeable__factory.SBTUpgradeable__factory;
  }
});
Object.defineProperty(exports, "TradeTrustSBT__factory", {
  enumerable: true,
  get: function get() {
    return _TradeTrustSBT__factory.TradeTrustSBT__factory;
  }
});
Object.defineProperty(exports, "TradeTrustTokenBaseURI__factory", {
  enumerable: true,
  get: function get() {
    return _TradeTrustTokenBaseURI__factory.TradeTrustTokenBaseURI__factory;
  }
});
Object.defineProperty(exports, "TradeTrustTokenBase__factory", {
  enumerable: true,
  get: function get() {
    return _TradeTrustTokenBase__factory.TradeTrustTokenBase__factory;
  }
});
Object.defineProperty(exports, "TradeTrustTokenBurnable__factory", {
  enumerable: true,
  get: function get() {
    return _TradeTrustTokenBurnable__factory.TradeTrustTokenBurnable__factory;
  }
});
Object.defineProperty(exports, "TradeTrustTokenMintable__factory", {
  enumerable: true,
  get: function get() {
    return _TradeTrustTokenMintable__factory.TradeTrustTokenMintable__factory;
  }
});
Object.defineProperty(exports, "TradeTrustTokenRestorable__factory", {
  enumerable: true,
  get: function get() {
    return _TradeTrustTokenRestorable__factory.TradeTrustTokenRestorable__factory;
  }
});
var _RegistryAccess__factory = require("./RegistryAccess__factory");
var _SBTUpgradeable__factory = require("./SBTUpgradeable__factory");
var _TradeTrustSBT__factory = require("./TradeTrustSBT__factory");
var _TradeTrustTokenBase__factory = require("./TradeTrustTokenBase__factory");
var _TradeTrustTokenBaseURI__factory = require("./TradeTrustTokenBaseURI__factory");
var _TradeTrustTokenBurnable__factory = require("./TradeTrustTokenBurnable__factory");
var _TradeTrustTokenMintable__factory = require("./TradeTrustTokenMintable__factory");
var _TradeTrustTokenRestorable__factory = require("./TradeTrustTokenRestorable__factory");